import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {OepApiService} from "../../services/oep-api.service";
import {map, Observable, Subject, takeUntil, tap} from "rxjs";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import {ElementDto} from "@rsmu/oep-api/model/elementDto";
import {ActivatedRoute, Router} from "@angular/router";
import {animate, state, style, transition, trigger} from "@angular/animations";
import { SpinnerComponent } from '../spinner/spinner.component';
import { NgIf, NgFor, NgClass, NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IomModuleService } from '../../services/iom-module.service';

type ElementDtoExt = ElementDto & ({
  expandable: boolean,
  expanded: boolean,
  animationState: 'start' | 'end'
});

@Component({
    selector: 'app-navigation-dialog',
    templateUrl: './navigation-dialog.component.html',
    styleUrls: ['./navigation-dialog.component.scss'],
    animations: [
        trigger('animateOpenCloseSublevel', [
            transition(':enter', [
                style({ height: 0 }),
                animate('200ms', style({ height: '*' })),
            ]),
            transition(':leave', [
                animate('200ms', style({ height: 0 }))
            ])
        ])
    ],
    standalone: true,
    imports: [MatDialogModule, MatIconModule, NgIf, NgFor, NgClass, NgTemplateOutlet, SpinnerComponent, AsyncPipe]
})
export class NavigationDialogComponent implements OnInit, OnDestroy {

  get iomTitle() {
    return this.data.iomTitle;
  }

  get iomType () {
    return this.data.iomType;
  }

  navMenu$?: Observable<ElementDtoExt[] | undefined> | undefined;
  private destroy$ = new Subject<void>();
  iomType$?: Observable<{ type: string }>;

  constructor(
    private dialogRef: MatDialogRef<NavigationDialogComponent>,
    private oep: OepApiService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {}

  goToElement(el: any) {
    if(!el.enabled) {
      return;
    }
    this.router.navigate(['step', el.id], {relativeTo: this.route.firstChild?.firstChild})
    this.dialogRef.close();
  }

  menuElementsToTreeElements(elements: Array<ElementDto> | undefined): ElementDtoExt[] | undefined {
    if(!elements) {
      return undefined;
    }
    return recursiveSetElements(elements, 0);
    function recursiveSetElements(elements: Array<ElementDto> | undefined,  level: number): ElementDtoExt[] | undefined {
      if (elements) {
        return elements.map(e => {
          const treeElement: any = {...e, level: level, expandable: false, animationState: 'start'}
          treeElement.level = level
          treeElement.expandable = !!treeElement.elements.length
          if(treeElement.expandable) {
            treeElement.elements = recursiveSetElements(e.elements, level + 1);
          }
          return treeElement;
        });
      } else {
        return undefined;
      }
    }
  }

  ngOnInit(): void {
    this.navMenu$ = this.oep.getNavMenu$(this.data.iomId)
      .pipe(
        takeUntil(this.destroy$),
        map(nav => this.menuElementsToTreeElements(nav.elements))
    );

    this.iomType$ = this.oep.getTitle$(this.data.iomId)
    .pipe(
      takeUntil(this.destroy$),
      map(iomTitle => ({
        type: iomTitle.type?.shortName || iomTitle.type?.name || ''
      }))
    );
  }

  handleExpansionClick(element: ElementDtoExt) {
    element.expanded = !element.expanded;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
